module.exports = __webpack_public_path__ + "static/media/policiaVila.ea3f2b6c.webp";